import { render, staticRenderFns } from "./RelationAccount.vue?vue&type=template&id=5cbe2dca&scoped=true"
import script from "./RelationAccount.vue?vue&type=script&lang=js"
export * from "./RelationAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbe2dca",
  null
  
)

export default component.exports